import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { CtaDialog } from './CtaDialog';
import { useState } from 'react';
import usePageblockEvents from '../../../../../hooks/usePageblockEvents';

interface HeaderWithPaywallCtaProps {
  headerText: string;
  subHeaderText: string;
  imgSrc: string;
  imgAlt: string;
  name: string;
  buttonText: string;
  bottomNote?: string;
}

export const PageblockHeaderWithCta = ({
  headerText,
  subHeaderText,
  imgSrc,
  imgAlt,
  name,
  buttonText,
  bottomNote,
}: HeaderWithPaywallCtaProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { sendOpenCtaDialogEvent } = usePageblockEvents();

  return (
    <Stack
      direction="row"
      sx={{
        background: colors.grey[100],
        p: '64px 102px',
        alignItems: 'center',
        width: '100%',
      }}
      justifyContent="center"
    >
      {isDialogOpen && (
        <CtaDialog name={name} onClose={() => setIsDialogOpen(false)} />
      )}
      <Stack direction="row" sx={{ width: '1080px', gap: 18 }} justifyContent="space-between">
        <Stack gap={4}>
          <Stack gap={1}>
            <Typography variant="h1-medium" color={colors.night[900]}>
              {headerText}
            </Typography>
            <Typography variant="body" color={colors.night[900]}>
              {subHeaderText}
            </Typography>
          </Stack>
          <Box>
            <Button
              size="medium"
              onClick={() => {
                sendOpenCtaDialogEvent();
                setIsDialogOpen(true);
              }}
            >
              {buttonText}
            </Button>
          </Box>

          {bottomNote && (
            <Stack width="448px">
              <Typography variant="caption" color={colors.grey[700]}>
                {bottomNote}
              </Typography>
            </Stack>
          )}
        </Stack>
        <img src={imgSrc} alt={imgAlt} style={{ height: '100%', width: '436px' }} />
      </Stack>
    </Stack>
  );
};
